"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";

type Media = {
  id: number;
  file_path: string;
  caption?: string;
  credit?: string;
  is_primary: boolean;
};

export default function MediaManager({
  entityType,
  entityId,
  items,
}: {
  entityType: "performer" | "show";
  entityId: number;
  items: Media[];
}) {
  const router = useRouter();
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  async function upload(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setUploading(true);
    setError("");
    const fd = new FormData(e.currentTarget);
    fd.set("entityType", entityType);
    fd.set("entityId", String(entityId));
    const res = await fetch("/api/media/upload", { method: "POST", body: fd });
    const data = await res.json();
    setUploading(false);
    if (!res.ok) {
      setError(data.error || "Erreur upload");
      return;
    }
    e.currentTarget.reset();
    router.refresh();
  }

  async function remove(id: number) {
    if (!confirm("Supprimer cette photo ?")) return;
    await fetch(`/api/media/${id}?entityType=${entityType}`, { method: "DELETE" });
    router.refresh();
  }

  async function primary(id: number) {
    await fetch(`/api/media/${id}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ entityType, entityId, isPrimary: true }),
    });
    router.refresh();
  }

  return (
    <div>
      <form className="media-upload" onSubmit={upload}>
        {error && <div className="form-error">{error}</div>}
        <div className="form-grid form-grid-4">
          <label className="span-2">
            <span>Photo *</span>
            <input type="file" name="file" accept="image/jpeg,image/png,image/webp" required />
          </label>
          <label><span>Légende</span><input name="caption" /></label>
          <label><span>Crédit photo</span><input name="credit" /></label>
        </div>
        <div className="form-inline-action">
          <label className="checkbox-line">
            <input type="checkbox" name="isPrimary" value="1" /> Définir comme photo principale
          </label>
          <button className="secondary-button" disabled={uploading}>
            {uploading ? "Envoi…" : "Ajouter la photo"}
          </button>
        </div>
      </form>

      <div className="media-grid">
        {items.map((m) => (
          <div className="media-card" key={m.id}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src={m.file_path} alt={m.caption || ""} />
            <div className="media-meta">
              {m.is_primary && <span className="primary-photo">Photo principale</span>}
              <strong>{m.caption || "Sans légende"}</strong>
              <small>{m.credit ? `© ${m.credit}` : "Crédit non renseigné"}</small>
              <div className="media-actions">
                {!m.is_primary && <button onClick={() => primary(m.id)}>Principale</button>}
                <button className="danger-link" onClick={() => remove(m.id)}>Supprimer</button>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && (
          <div className="empty compact-empty">
            <strong>Aucune photo</strong>
            <span>Ajoutez une photo principale puis complétez la galerie.</span>
          </div>
        )}
      </div>
    </div>
  );
}
